import { getWeek, getWeekYear } from "date-fns";

const WEEK_OPTIONS = {
  weekStartsOn: 0,          // domingo
  firstWeekContainsDate: 4, // regra da semana 1
};

export function getEpidemiologicalWeek(date) {
  return {
    week: getWeek(date, WEEK_OPTIONS),
    year: getWeekYear(date, WEEK_OPTIONS),
  };
}

export { WEEK_OPTIONS };